import _ from '@lodash';
import Icon from '@material-ui/core/Icon';
import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { AgGridReact } from 'ag-grid-react';
import '../../../../styles/ag-custom.css';
import useRouter from '@fuse/hooks/useRouter';
import { setfilterlist, setrowGroupModel } from '../store/filterParamsReducer';
import { openFormViewerDialog, setFromData, setUserInfo } from '../store/formViewDialogReducer';
import axios from "@fuse/utils/axios";
import useToast from '@fuse/hooks/useToast';
import { countries } from '@fuse/utils/countryName';
import 'ag-grid-enterprise';
import 'styles/ag-grid-header-style.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import GeneralModal from '@fuse/components/Modal/GeneralModal';
import Tooltip from '@material-ui/core/Tooltip';
import AlphabeticalSorting from '@fuse/utils/alphabeticalSort';
import { setQuickFilter } from '../../reports/store/reportViewDialogReducer';
import AgGridFilterGroupView from '@fuse/components/AgGridFilterGroupView';
import CustomFilter from '@fuse/components/AgGridFilterGroupView/components/CustomFilter';
import ActivityAgGridListingSameAsSam from '@fuse/components/ActivitieLogs/activitiesAgGridListingSameAsSam';

const useStyles = makeStyles({
	layoutRoot: {},
	head: {
		position: "sticky",
		top: 0
	},
	root: {
		// minWidth: 275,
	},
	title: {
		fontSize: 14,
	},
	pos: {
		marginBottom: 12,
	},
	searchbar: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-end',
		margin: '5px 5px 5px 0',
		height: '28px',
	},
	buttonSquare: {
		borderRadius: '5px'
	}
});

function ListView(props) {
	const [gridApi, setGridApi] = useState(null);
	const table_name = 'USER';
	const gridRef = useRef();
	const [windowHeight, setWindowHeight] = useState(window.innerHeight - 320);
	const [userData, setUserData] = useState(null);
	const [open, setOpen] = useState(false);
	const [fullWidth, setFullWidth] = useState(true);
	const [maxWidth, setMaxWidth] = useState('lg');
	const [departmentMenu, setDepartmentMenu] = useState([])
	const [rowGroupPanelShow, setRowGroupPanelShow] = useState('never');
	const [tabValue, setTabValue] = useState(0)
	const [groupByArr, setGroupByArr] = useState([])
	const [logs, setLogs] = useState([]);
	const [loadingActivityLog, setLoadingActivityLog] = useState(false);

	const dispatch = useDispatch();
	const router = useRouter();
	const toast = useToast(dispatch);
	const [displayButton, setDisplayButton] = useState(false);
	const [filterApplied, setFilterApplied] = useState(false);
	const skipHeader = [
		"id", "user_companies_id", "roles_end_users_id", "created_at",
		"updated_at", "entity_external_platform_id", "company_id",
		"platform_customer_id", "portal_user", "password", "google_id",
		"microsoft_id", "reset_token", "is_set_password", "password_reset_id",
		"photoURL", "sales_lead_name", "login_enabled", "start_date", "end_date",
		"user_added", "first_login", "company_creator", "role_name",
		"miltiple_role", "multiple_role_end_users", "department", "dept_id",
		"user_start_date", "user_end_date", "user_type", "original_info", "last_login", 'last_accessed', 'user_company'
	]
	const query_data = useSelector((state) => state.reportApp.reportViewDialogReducer.quick_filter);
	const tab_value = useSelector(
		(state) => state.reportApp.reportViewDialogReducer.tab_value
	);


	const handleClickOpen = (data) => {
		router.push(`/user/${data.id}`)
	};

	function getUserInfo(user_id) {
		axios.get(`/end-user/view-client/${user_id}`)
			.then(results => {
				dispatch(setUserInfo(results.data.data))
			}
		)
	}

	const Close = () => {
		setOpen(false);
	};

	function handelEdit(data) {
		dispatch(setFromData(data))
		dispatch(openFormViewerDialog())
	}

	const handleOpenDeleteDialog = (data) => {
		setUserData(data)
	}

	const handleClose = () => {
		setUserData(null)
	}

	function handleDelete() {
		axios.delete(`/user/delete/${userData.id}`).then((res) => {
			if (res.status === 201) {
				toast.error(res.data.message)
				handleClose()
			}
			else {
				handleClose()
				toast.success(res.data.message)
				props.refresh()
			}
		}).catch((err) => {
			toast.error(err.response.data.message)
		})
	}

	function formatString(str) {
		if (!str) return ''
		if (str == 'miltiple_role_name') return 'Role Name'
		return str.split('_').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' ')
	}

	const onGridReady = (params) => {
		gridRef.current = params;
		setGridApi(params);
		props.endUsersAccounts.forEach((list) => {
			for (const [fieldName, value] of Object.entries(list)) {
				if (value === '' || value == null) {
					if (fieldName === 'last_accessed') {
						list[fieldName] = 'Not accessed'
					} else {
						list[fieldName] = `No ${formatString(fieldName)}`
					}
				}
			}
		})
		if (router.query.report_name == undefined) {
			loadInitialState(params);
			dispatch(setfilterlist({}));
			dispatch(setrowGroupModel([]));
		} else {
			getReport(params);
		}
	}

	function onFilterChanged(event) {
		const rows = event.api.getFilterModel();
		dispatch(setfilterlist(rows));
		saveView("N/A", rows, gridRef.current.filterModelArr)
		// validation for no-overlay 
		const total_rows = event.api.getDisplayedRowCount();
		if (total_rows === 0) {
			event.api.showNoRowsOverlay();
		} else {
			event.api.hideOverlay();
		}
	}

	function onSortChanged(params) {
		if (router.query.report_name == undefined) {
			const rows = params.api?.getColumnState();
			dispatch(setrowGroupModel(rows));
			saveView(rows);
		}
	}

	function getReport(event) {
		const { report_name } = router.query;
		const table_name = "user";
		axios.get(`/reports/view-report?table_name=${table_name}&report_name=${report_name}`)
			.then(results => {
				const model = JSON.parse(results.data.data.filter);
				event.api.setFilterModel(model);
				const row_model = JSON.parse(results.data.data.row_model);
				event.api?.getColumnState(row_model);
			})
			.catch(err => {
				console.log(err);
			})
	}

	function loadInitialState(params) {
		axios
			.get(`/user-view/show-view-order?table_name=${table_name}`)
			.then((results) => {
				const { data } = results.data;
				if (data !== null) {
					const order = JSON.parse(data.order);
					const filter = JSON.parse(data.filter);
					gridRef.current = { ...gridRef.current, filterModelArr: filter }
					params?.api?.applyColumnState({ state: order });
					params?.api.setFilterModel(filter);
					if (Object.keys(filter)?.length) {
						setFilterApplied(true)
					}
				}
			})
			.catch((err) => {
				console.log(err);
			});
	}

	useEffect(() => {
		if (filterApplied) {
			toast.success("Filters have been applied")
		}
	}, [filterApplied])

	function saveView(rows, filter, filterModelArr = null) {
		let payload = {}
		if (rows == 'N/A') {
			payload = {
				filter: JSON.stringify(filterModelArr ?? filter),
				table_name
			}
		} else {
			payload = {
				order: JSON.stringify(rows),
				table_name
			}
		}
		axios.post('/user-view/save-view-order', payload)
			.then(() => {
				console.log('view updated')
			})
			.catch(err => {
				console.log(err);
			})
	}

	const onColumnMoved = (params) => {
		if (router.query.report_name == undefined) {
			const rows = params.api?.getColumnState();
			saveView(rows);
			dispatch(setrowGroupModel(rows))
		}
	}

	const onColumnPinned = (params) => {
		if (router.query.report_name == undefined) {
			const rows = params.api?.getColumnState();
			saveView(rows);
			dispatch(setrowGroupModel(rows))
		}
	}

	function onColumnVisible(params) {
		const rows = params.api?.getColumnState();
		dispatch(setrowGroupModel(rows))
		const total_no_of_columns = rows.length;
		let total_hidden_columns = 0;
		rows.forEach(row => {
			const { hide } = row;
			if (hide) {
				++total_hidden_columns;
			}
		});
		if (total_hidden_columns < total_no_of_columns) {
			if (router.query.report_name == undefined) {
				saveView(rows)
			}
		}
	}

	function onColumnRowGroupChanged(event) {
		if (router.query.report_name == undefined) {
			const rows = event.api?.getColumnState();
			const first_row = rows[1];
			if (first_row.colId !== "ag-Grid-AutoColumn") {
				dispatch(setrowGroupModel(rows));
				saveView(rows);
			} else {
				dispatch(setrowGroupModel(rows));
			}
		}
		const api = event?.api;
    if (!api) return;
    const groupedColumns = api.getRowGroupColumns();
    if (groupedColumns.length === 0) setGroupByArr([]);
    else setGroupByArr(groupedColumns);
		onRowGroupOpenedAutoSize();
	}

	function onRowGroupOpenedAutoSize() {
		const allColumnIds = [];
		gridApi?.api.getColumnState().forEach((column) => {

			if (column.colId === 'ag-Grid-AutoColumn') {
				allColumnIds.push(column.colId);
			}
		});
		gridApi?.api.autoSizeColumns(allColumnIds, false);
	}

	function onCellValueChanged(e) {
		let { first_name } = e.data
		let { last_name } = e.data
		let { title } = e.data
		let { phone } = e.data.original_info
		let { address } = e.data.original_info
		let { address_2 } = e.data.original_info
		let { city } = e.data.original_info
		let { state } = e.data.original_info
		let { zipcode } = e.data.original_info
		let { country } = e.data.original_info
		let { emp_no } = e.data.original_info
		let { start_date } = e.data.original_info
		let { end_date } = e.data.original_info
		let department = null

		if (e.colDef.field == "first_name") {
			first_name = e.newValue
		}
		if (e.colDef.field == "last_name") {
			last_name = e.newValue
		}
		if (e.colDef.field == "title") {
			title = e.newValue
		}
		if (e.colDef.field == "phone") {
			phone = e.newValue
		}
		if (e.colDef.field == "address") {
			address = e.newValue
		}
		if (e.colDef.field == "address_2") {
			address_2 = e.newValue
		}
		if (e.colDef.field == "city") {
			city = e.newValue
		}
		if (e.colDef.field == "state") {
			state = e.newValue
		}
		if (e.colDef.field == "zip") {
			zipcode = e.newValue
		}
		if (e.colDef.field == "country") {
			country = e.newValue
		}
		if (e.colDef.field == "department_name") {
			department = departmentMenu.find(item => item.label == e.newValue)
		}
		if (e.colDef.field == "emp_no") {
			emp_no = e.newValue
		}
		if (e.colDef.field == "start_date") {
			start_date = e.newValue
		}
		if (e.colDef.field == "end_date") {
			end_date = e.newValue
		}
		const payload = {
			user_id: Number(e.data.id),
			first_name: e.data.first_name,
			last_name: e.data.last_name,
			title: e.data.title,
			email: e.data.email,
			login_enabled: e.data.login_enabled ?? false,
			role_id: e.data.multiple_role_end_users.map((role) => {
				return role.roles_end_user_id
			}),
			emp_no: emp_no || '',
			phone: phone || '',
			address: address || '',
			address_2: address_2 || '',
			city: city || '',
			state: state || '',
			zipcode: zipcode || '',
			country: country || '',
			department_id: department ? department.id : (e.data.department?.id ?? null),
			start_date: start_date ? start_date.split('T')[0] : '',
			end_date: end_date ? end_date.split('T')[0] : '',
		}
		if (!payload.email) {
			toast.error('Email is required')
			props.refresh()
			return
		} if (!payload.first_name) {
			toast.error('First Name is required')
			props.refresh()
			return
		} if (!payload.last_name) {
			toast.error('Last Name is required')
			props.refresh()
			return
		} if (!payload.title) {
			toast.error('Title is required')
			props.refresh()
			return
		}
		if (phone && !phone.match(/[0-9]{3}-[0-9]{3}-[0-9]{4}$/)) {
			toast.error('Phone number should be in 000-000-0000 format')
			props.refresh()
			return
		}
		axios.post('/user/update', payload).then(response => {
			if (response.status == 201) {
				toast.error(response.data.message)
				props.refresh()
			} else {
				toast.success('User updated successfully.')
				props.refresh()
			}
		}).catch(err => {
			console.log('212=>', err);
			toast.error('Something went wrong!')
		})
	}

	useEffect(() => {
		return () => {
			dispatch(setQuickFilter(null))
		}
	}, [props.endUsersAccounts])

	const onRangeSelectionChanged = (params) => {

		let columnCount = 0;
		let startRowIndex = 0;
		let endRowIndex = 0;

		const rows = params.api.getCellRanges();

		if (rows.length != 0) {
			columnCount = params.api.getCellRanges()[0].columns.length;
			startRowIndex = params.api.getCellRanges()[0].startRow.rowIndex;
			endRowIndex = params.api.getCellRanges()[0].endRow.rowIndex;
		}

		if (columnCount > 1 || startRowIndex != endRowIndex) {
			setDisplayButton(true);
		} else {
			setDisplayButton(false);
		}
	}

	const generateHeaderLabel = (header) => {
		if (header == 'emp_no') {
			return 'Employee Number'
		} if (header === "state") {
			return 'State/Province';
		}
		return header.split('_').map(word => {
			return word.charAt(0).toUpperCase() + word.substring(1)
		}).join(' ')
	}

	function valueFormatter(params) {
		// if(params.colDef.field === 'last_accessed'){
		// 	if(params.value && params.value !== 'Not accessed'){
		// 		const date = new Date(params.value)
		// 		return `${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}-${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
		// 	}else{
		// 		return params.value
		// 	}
		// }
		// else return params.value
		return params.value
	}

	useEffect(() => {
		gridRef.current.api?.setQuickFilter(query_data);
	}, [query_data])

	useEffect(() => {
		const onBtStopEditing = () => {
			gridRef?.current?.api?.stopEditing();
		}
		window.addEventListener('click', onBtStopEditing);
		return () => {
			window.removeEventListener('click', onBtStopEditing);
		};
	}, [])

	const fetchDepartmentSuggestions = () => {
		axios.get("/department").then((response) => {
			const department = AlphabeticalSorting(response.data.data, 'department_name')
			setDepartmentMenu(department.map((item) => {
				return {
					id: item.id,
					label: item.department_name
				}
			}))
		}).catch(err => {
			console.log('164=>', err);
			toast.error('Something went wrong!')
		})
	}

	useEffect(() => {
		fetchDepartmentSuggestions()
	}, [])

	const frameworkComponents = {
		customFilter: CustomFilter,
	};

	const handleChildClick = (value) => {
		setTabValue(value)
	};

	function formatLogs(data) {
		return data.map((item) => {
			return {
				id: item.id,
				action_id: `act${item.id}`,
				action_date_and_time: item.created_at,
				user_name: item.user ? `${item.user.first_name} ${item.user.last_name} (${item.user.email})` : item.end_user_name,
				name: item.user_name,
				action: item.action_name,
				description: item.comment,
				previous_value: item.previous_data,
				current_value: item.current_data,
				field_name: item.action_field_name,
				user_role: item.user_role_name,
				company_name: item?.user_company?.company_name,
			}
		})
	}

	function getLogs() {
		setLoadingActivityLog(true)
		axios.get('/user/all-activities')
			.then(({ data }) => {
				setLogs(formatLogs(data.data.activities));
				setLoadingActivityLog(false)
			})
			.catch(err => {
				console.log('cannot fetch logs');
			})
	}

	useEffect(() => {
		if (tabValue == 1) {
			getLogs()
			setFilterApplied(false)
		}
	}, [tabValue])

	useEffect(() => {
		setTabValue(tab_value)
	}, [tab_value])

	return (
		<>

			{(tabValue == 0) && <AgGridFilterGroupView tableRef={gridRef} setRowGroupPanelShow={setRowGroupPanelShow}
				groupByArrFromList={groupByArr}
				tableName="user" logs={logs} displayTableName="Users"
				onClick={handleChildClick}
			/>}
			{(tabValue == 1) && (<ActivityAgGridListingSameAsSam module="user" logs={logs} displayTableName="Users"
				addPermission={props.createSLAggrementPermission}
				loadingActivityLog={loadingActivityLog}
			/>)}

			{(tabValue == 0) && <div
				className="ag-theme-alpine"
				style={{
					width: "100%",
					height: windowHeight + 105,
					fontSize: '11px'
				}}
			>
				{/* {filterApplied && <p style={{margin: '4px'}}>Filters have been applied</p>} */}
				<AgGridReact
					ref={gridRef}
					theme='legacy'
					suppressRowClickSelection
					onGridReady={onGridReady}
					animateRows
					rowData={props.endUsersAccounts}
					rowHeight={30}
					headerHeight={44}
					// Set the desired sheet name
					defaultExcelExportParams={{
						sheetName: 'Dalos-Source'
					}}
					// no rows overlay 
					overlayNoRowsTemplate="<span>No Result Found</span>"

					// Row Grouping conditions
					showOpenedGroup
					suppressDragLeaveHidesColumns
					suppressMakeColumnVisibleAfterUnGroup
					rowGroupPanelShow={rowGroupPanelShow}

					onColumnMoved={onColumnMoved}
					onColumnPinned={onColumnPinned}
					onColumnVisible={onColumnVisible}
					onSortChanged={onSortChanged}

					groupHeaderHeight={1}
					components={frameworkComponents}
					floatingFiltersHeight={40}

					// status bar enabled on range selection
					enableRangeSelection
					statusBar={{
						statusPanels: [
							{
								statusPanel: 'agAggregationComponent'
							},
						],
					}}

					// to check the the no. of rows selected during range selection
					onRangeSelectionChanged={onRangeSelectionChanged}

					onFilterChanged={onFilterChanged}

					// on column group changed
					onColumnRowGroupChanged={onColumnRowGroupChanged}

					cacheQuickFilter

					pagination
					defaultColDef={{
						enableRowGroup: true,
						resizable: true
					}}
					columnDefs={[
						{
							lockPosition: true,
							rowSelection: "single",
							width: 120,
							minWidth: 120,
							maxWidth: 120,
							suppressSizeToFit: true,
							headerName: "Actions",
							suppressMenu: true,          
							suppressHeaderMenuButton: true,
							sortable: false,
							pinned: 'right',
							className: "action_field",
							lockPinned: true,
							cellRenderer: ({ data }) => {
								if (data) {
									return (
										<>
											<Tooltip id="view" title="View" placement="top">
												<Icon
													onClick={() => handleClickOpen(data)}
													fontSize='small'
													style={{
														color: '#1d2939',
														paddingBottom: '3px',
														paddingRight: '30px',
														fontSize: '15px', cursor: 'pointer'
													}}
												>
													visibility
												</Icon>
											</Tooltip>
										</>
									)
								} 
									return (<></>)

							}
						},
						...Object.keys(props.endUsersAccounts[0])
							.filter((header) => !skipHeader.includes(header))
							.map((header) => {
								const baseCol = {
									field: header,
									flex: 1,
									minWidth: 200,
									sortable: true,
									filter: "agTextColumnFilter",
									suppressSizeToFit: true,
									headerComponent: (props) => CustomFilter(props, header, gridRef),
								};
								if (header === 'email') {
									return {
										...baseCol,
										headerName: generateHeaderLabel(header),
									}
								}
								if (header == 'miltiple_role_name') {
									return {
										...baseCol,
										headerName: 'Role Name',
										cellEditorPopup: true,
										editable: false
									}
								}
								if (header == 'department_name') {
									return {
										...baseCol,
										editable: true,
										onCellValueChanged,
										headerName: generateHeaderLabel(header),
										cellEditorParams: { values: departmentMenu.map(department => department.label) },
										cellEditor: 'agRichSelectCellEditor'
									}
								}
								if (header == 'country') {
									return {
										...baseCol,
										editable: true,
										suppressRowClickSelection: true,
										onCellValueChanged,
										headerName: generateHeaderLabel(header),
										cellEditorParams: { values: countries.map(item => `${item.name}`) },
										cellRenderer: 'GenderRenderer',
										cellEditor: 'agRichSelectCellEditor'
									}
								}
								if (header == 'source_') {
									return {
										...baseCol,
										suppressRowClickSelection: true,
										headerName: generateHeaderLabel(header),
										cellEditorParams: { values: countries.map(item => `${item.name}`) },
										cellRenderer: 'GenderRenderer',
										cellEditor: 'agRichSelectCellEditor',
									}
								}

								return {
									...baseCol,
									editable: true,
									suppressRowClickSelection: true,
									onCellValueChanged,
									headerName: generateHeaderLabel(header),
									valueFormatter
								}
							})]}
				/>
				<GeneralModal
					open={userData}
					title="Delete User"
					text={<h4>Are you sure to delete this user named as <b>{`${userData?.first_name} ${userData?.last_name}`}</b>?</h4>}
					handleClose={handleClose}
					handleConfirm={handleDelete}
				/>
			</div>}
		</>
	);
}

export default ListView
